var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9196 0.333496C12.1996 0.333496 0.25293 12.2802 0.25293 27.0002C0.25293 41.7202 12.1996 53.6668 26.9196 53.6668C41.6396 53.6668 53.5863 41.7202 53.5863 27.0002C53.5863 12.2802 41.6663 0.333496 26.9196 0.333496ZM23.5863 35.0802C23.5863 36.3602 23.0529 36.8668 21.6929 36.8668H18.2263C16.8663 36.8668 16.3329 36.3602 16.3329 35.0802V18.9202C16.3329 17.6402 16.8663 17.1335 18.2263 17.1335H21.6663C23.0263 17.1335 23.5596 17.6402 23.5596 18.9202V35.0802H23.5863ZM37.6663 35.0802C37.6663 36.3602 37.1329 36.8668 35.7729 36.8668H32.3329C30.9729 36.8668 30.4396 36.3602 30.4396 35.0802V18.9202C30.4396 17.6402 30.9729 17.1335 32.3329 17.1335H35.7729C37.1329 17.1335 37.6663 17.6402 37.6663 18.9202V35.0802Z",
    fill: "#14142A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBlack);
export default __webpack_public_path__ + "static/media/pause-black.1a1d60ba594c594b441e8be9fb2f3603.svg";
export { ForwardRef as ReactComponent };